/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_CollectedInputs */

const cs_deal_provision_collected = /** @type {(inputs: Deal_Provision_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybráno`)
};

const en_deal_provision_collected = /** @type {(inputs: Deal_Provision_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collected`)
};

/**
* | output |
* | --- |
* | "Collected" |
*
* @param {Deal_Provision_CollectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_collected = /** @type {((inputs?: Deal_Provision_CollectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_CollectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_collected(inputs)
	return cs_deal_provision_collected(inputs)
});